import { User } from './user';


export class ShiftHistory {
    logged: Date;
    user: User;
    is_locked: boolean;
    is_for_sale: boolean;
}
